import React from 'react';
import css from './picture.module.scss';
import { fileAPI } from '../../../../../entities/file/api/api';

interface TemplatePictureProps {
    preview: string | null,
}

export const TemplatePicture = (props: TemplatePictureProps) => {
	const { preview } = props;

	return preview ? (
		<div className={css.picture_wrapper}>
			<img src={`/api/file/system/${preview}`} alt="preview" />
		</div>
	) : (
		<div className={css.without_preview}>
			<img src="/logo.svg" alt="Пустой шаблон" />
		</div>
	);
};

